import { render, staticRenderFns } from "./TableScroller.vue?vue&type=template&id=31f3762e&lang=pug&"
import script from "./TableScroller.vue?vue&type=script&lang=js&"
export * from "./TableScroller.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports